var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-container',{staticClass:"text-center my-4"},[_c('b-card',[_c('h2',{staticStyle:{"font-weight":"bold"}},[_vm._v(" "+_vm._s(_vm.$t('active_email_and_mobile_to_countinu'))+" ")]),_c('QuickRegister',{attrs:{"redirect-url-name":"investModule-select-plan-type","questions":"{}"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }